<div class = "ui-field">
    <div #trigger class = "ui-select-container" [ngClass] = "{
        'ui-select-option-selected': isValidAddress(),
        'ui-field-invalid': !isValidAddress() && !readonly && touched,
        'ui-select-address-view': readonly,
    }" (click)="eventOpenAddress()">
        @if (!isValidAddress() && !readonly) {
            <div class = "ui-title">
                <span>Endereço</span>
            </div>
        } @else if (address) {
            <div class = "ui-select-icon">
                <i class = "uii-garage"></i>
            </div>
            <div class = "ui-detail-container">
                <div class = "ui-title">
                    {{ address.streetName }}, {{ address.number }}, {{ address.neighborhood }}
                </div>
                <span class = "ui-sub-title">
                    {{ address.city }}, {{ address.state }} - {{ address.zipCode.slice(0, 5) + '-' + address.zipCode.slice(5) }}
                </span>
                <div class = "ui-label">
                    @if (address.complement) {
                        <span>Complemento: {{ address.complement }}</span>
                    }
                    @if (address.trackingCode) {
                        <span>Tracking Code: {{ address.trackingCode }}</span>
                        <span>Destinatário: {{ address.name }}</span>
                    }
                </div>
            </div>
        } @else if (readonly) {
            <div class = "ui-select-icon">
                <i class = "uii-garage"></i>
            </div>
            <div class = "ui-detail-container">
                <div class = "ui-title">
                    Endereço de Envio
                </div>
                <div class = "ui-sub-title">
                    Ainda não vinculado
                </div>
            </div>
        }
    </div>
</div>

<ng-template #addressTemplate>
    <div class = "ui-select-menu">
        <div class = "ui-title">
            <i class = "uii-location-dot"></i>
            <span>Endereço</span>
            <div class = "ui-select-menu-close" (click) = "eventCloseOverlay()">
                <button class = "ui-button">
                    <i class = "uii-times"></i>
                </button>
            </div>
        </div>
        <form class = "ui-form" (click)="$event.stopPropagation()" [formGroup] = "formGroup">
            <div class = "ui-field-group">
                <div class = "ui-field ui-secondary ui-address-cep ui-xm">
                        <span class = "ui-field-label">
                            CEP*
                        </span>
                    <input (input) = "eventZipCodeChanged($event)" type = text placeholder = "00000-000" mask = "00000-000" formControlName = "zipCode">
                    <div class = "ui-field-invalid" *ngIf = "formGroup.get('zipCode')?.hasError('zipCode')">Cep inválido</div>
                </div>
                <div class = "ui-field ui-secondary ui-xm">
                        <span class = "ui-field-label">
                            País*
                        </span>
                    <input  type = text placeholder = "Brasil" formControlName = "country">
                </div>
            </div>
            @if (isValidCep()) {
                <div class = "ui-field-group">
                    <div class = "ui-field ui-secondary ui-xg">
                            <span class = "ui-field-label">
                                Rua*
                            </span>
                        <input  type = text placeholder = "Rua Abelio Gárcia" formControlName = "streetName">
                    </div>
                    <div class = "ui-field ui-secondary ui-xp">
                            <span class = "ui-field-label">
                                Número*
                            </span>
                        <input  type = number placeholder = "157" formControlName = "number">
                    </div>
                </div>
                <div class = "ui-field-group">
                    <div class = "ui-field ui-secondary ui-xm">
                            <span class = "ui-field-label">
                                Bairro*
                            </span>
                        <input  type = text placeholder = "Ivaí" formControlName = "neighborhood">
                    </div>
                    <div class = "ui-field ui-secondary ui-xm">
                            <span class = "ui-field-label">
                                Cidade*
                            </span>
                        <input  type = text placeholder = "Jacuí" formControlName = "city">
                    </div>
                </div>
                <div class = "ui-field-group">
                    <div class = "ui-field ui-secondary ui-xp">
                            <span class = "ui-field-label">
                                Estado*
                            </span>
                        <input  type = text placeholder = "MG" formControlName = "state">
                    </div>
                    <div class = "ui-field ui-secondary ui-xg">
                            <span class = "ui-field-label">
                                Complemento*
                            </span>
                        <input  type = text placeholder = "Casa B" formControlName = "complement">
                    </div>
                </div>
            }
        </form>
    </div>
</ng-template>
